import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import logo from "../assets/images/logo.png";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const links = [
  { name: "Home", path: "home" },
  { name: "About", path: "about" },
  { name: "Why Choose Us", path: "whyChooseUs" },
  { name: "Featured", path: "featured" },
  { name: "Screenshots", path: "screenshots" },
  { name: "Download App", path: "downloadApp" },
];

export default function Header() {
  const [activeLink, setActiveLink] = useState("home");

  return (
    <>
      <nav className="navbar navbar-expand-lg header-navbar" data-aos="fade-down">
        <div className="container px-4">
          
          {/* Logo */}
          <Link className="navbar-brand" to="/" data-aos="fade-right">
            <img src={logo} alt="Bazarna Logo" className="header-logo hover-scale-sm" />
          </Link>

          {/* Mobile Toggle */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNavbar"
          >
            <span className="navbar-toggler-icon" />
          </button>

          {/* Desktop Menu */}
          <div className="collapse navbar-collapse d-none d-lg-flex justify-content-center" data-aos="fade-up" data-aos-delay="200">
            <ul className="navbar-nav header-nav-links">
              {links.map((l, i) => (
                <li className="nav-item" key={l.path} data-aos="zoom-in" data-aos-delay={200 + i * 100}>
                  <ScrollLink
                    to={l.path}
                    smooth
                    duration={300}
                    spy
                    className={`nav-link ${
                      activeLink === l.path ? "active" : ""
                    }`}
                    onClick={() => setActiveLink(l.path)}
                  >
                    {l.name}
                  </ScrollLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Button */}
          <div className="d-none d-lg-block" data-aos="fade-left" data-aos-delay="300">
            <button className="become-seller-btn hover-rise-sm">
              Become a Seller
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Offcanvas */}
      <div
        className="offcanvas offcanvas-start d-lg-none"
        id="offcanvasNavbar"
      >
        <div className="offcanvas-header" data-aos="fade-right">
          <img src={logo} alt="Logo" className="header-logo hover-scale-sm" />
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
          />
        </div>

        <div className="offcanvas-body" data-aos="fade-up">
          <ul className="navbar-nav gap-3">
            {links.map((l, i) => (
              <li className="nav-item" key={l.path} data-aos="zoom-in" data-aos-delay={100 + i * 100}>
                <ScrollLink
                  to={l.path}
                  smooth
                  duration={300}
                  spy
                  className={`nav-link ${
                    activeLink === l.path ? "active" : ""
                  }`}
                  onClick={() => setActiveLink(l.path)}
                  data-bs-dismiss="offcanvas"
                >
                  {l.name}
                </ScrollLink>
              </li>
            ))}
          </ul>

          <button className="become-seller-btn mt-4 w-100 hover-rise-sm" data-aos="fade-up" data-aos-delay="500">
            Become a Seller
          </button>
        </div>
      </div>
    </>
  );
}
